import { render, staticRenderFns } from "./ModerateServer.vue?vue&type=template&id=247029b8&scoped=true&"
import script from "./ModerateServer.vue?vue&type=script&lang=js&"
export * from "./ModerateServer.vue?vue&type=script&lang=js&"
import style0 from "./ModerateServer.vue?vue&type=style&index=0&id=247029b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247029b8",
  null
  
)

export default component.exports